import * as React from 'react';

import {AuditLogFeatureGate} from '../../limits/feature-gates/audit-log-feature-gate';

import {AuditLogContent} from './audit-log-content';
import {AuditLogTabs} from './audit-log-tabs';
import type {ContentType} from './audit-log-wrapper';

import styles from './audit-log.module.css';

type Props = {
    selectedTab: ContentType;
    setSelectedTab: (tab: ContentType) => void;
    onParamChange: (params: any) => void;
    filterByUserId: string | null | undefined;
};

export function AuditLog(props: Props) {
    if (!NutClientConfig.hasAuditLog) {
        return <AuditLogFeatureGate />;
    }

    return (
        <div className={styles.container}>
            <AuditLogTabs selectedTab={props.selectedTab} onChange={props.setSelectedTab} />
            <AuditLogContent
                contentType={props.selectedTab}
                onParamChange={props.onParamChange}
                filterByUserId={props.filterByUserId}
            />
        </div>
    );
}
